import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_NUMBER_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
	useExisting: forwardRef(() => InputNumberComponent),
	multi: true,
};

@Component({
	selector: 'app-input-number',
	templateUrl: './input-number.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-number.component.scss'],
	providers: [INPUT_NUMBER_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputNumberComponent extends InputBase implements ControlValueAccessor {
	/**
	 * Set to false to hide the increase/decrease buttons
	 */
	@Input() showButtons = true;

	@Input() min: number = null;

	@Input() max: number = null;

	@Input() step: number = null;

	writeValue(value: any): void {
		const newVal = Number(value);
		this.value = Number.isNaN(newVal) ? value : newVal;
	}
}
